import { SearchFilterQuery } from "../jobs";

export interface WordExport {
  id: string;
  jobFilter: SearchFilterQuery;
  filePath: string | null;
  status: WordExportStatus;
  createdAt: Date;
  updatedAt: Date;
}

export enum WordExportStatus {
  PENDING = "PENDING",
  PROCESSING = "PROCESSING",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
}
